import { target } from '@libs/enums';
import { genMstColumns } from '@libs/templates/mst';
import type { Column } from '@ps-smart-cp/ppfw-client';
import { leaseCompanyMstRegistrationFieldConfig } from '../item-config';
import type { LeaseCompanyMstRegistration } from '../models';

const leaseCompanyMstColumns: Column<LeaseCompanyMstRegistration>[] = [
  ...genMstColumns<LeaseCompanyMstRegistration>(),
  {
    displayName: leaseCompanyMstRegistrationFieldConfig.phoneNo,
    renderCell: ({ row }) => row.phoneNo,
  },
  {
    displayName: leaseCompanyMstRegistrationFieldConfig.paymentDay,
    renderCell: ({ row }) => row.paymentDay,
    textAlign: 'right',
  },
  {
    displayName: leaseCompanyMstRegistrationFieldConfig.eligibleBillingProvider,
    renderCell: ({ row, locale }) =>
      target.toDisplay(row.eligibleBillingProvider ? target.enum.yes : target.enum.no, locale),
  },
];

export { leaseCompanyMstColumns };
